
import { Component, Vue, Prop } from "vue-property-decorator";
import { apiQueryFastCashSvipPopupInfo } from "@/req/pay";
@Component
export default class Logout extends Vue {
  public data: any = {
    leveImg: "",
  };
  public modalShow = false;
  public url = this.$HTTP_API.user.tradeCoin;
  public mounted() {
    this.getSvipPopupInfo();
  }
  public async getSvipPopupInfo() {
    const res = await apiQueryFastCashSvipPopupInfo();
    if (res.code == 200) {
      if (res.data) this.data = res.data;
      // this.data = {
      //   userId: 14618616,
      //   growthValue: 0,
      //   svipLevel: 8,
      //   svipLevelCount: 0,
      //   valueInfo: "单月极速提现额度:0元\n(本次为本月升级后补发额度)",
      //   rightDayLimitInfo: "单日极速提现额度:300元",
      //   grantRule: "svip升级到该等级时，自动发放1次",
      //   rightMessage: "提现快速到账\n滴滴滴",
      //   rightName: "极速提现",
      // };
      if (this.data.userId) {
        this.data.leveImg = require(`@/assets/img/svip/icon_dialog_svip_level${this.data.svipLevel}.png`);
        this.modalShow = true;
      }
    }
  }
}
